import classNames from 'classnames';

import { RichText } from '@components/RichText';
import { SanityImage } from '@components/SanityImage';

import { CmsQuoteSection } from '@interfaces/common';
import { breakpoints } from '@utils/device';

import styles from './QuoteSection.module.css';

export type QuoteSectionProps = Omit<CmsQuoteSection, '_key' | '_type'>;

export const QuoteSection: React.VFC<QuoteSectionProps> = ({
	author,
	authorRole,
	image,
	quote,
	backgroundColor,
	textColor,
}) => {
	const customProperties = {
		'--quote-section-color': textColor?.hex,
		'--quote-section-background-color': backgroundColor?.hex,
	} as React.CSSProperties;

	return (
		<section className={styles.wrapper} style={customProperties}>
			<div className={styles['image-wrapper']}>
				<SanityImage image={image} sizes={`${breakpoints.lg} 33vw, 100vw`} />
			</div>
			<div className={styles['text-wrapper']}>
				<figure className="stack-block">
					<blockquote className={classNames(styles.quote, 'fluid-font-t3')}>
						{quote}
					</blockquote>
					<figcaption>
						<span className={classNames(styles.author, 'fluid-font-t5-bold')}>
							{author}
						</span>
						<RichText
							className={classNames(
								styles['author-description'],
								'fluid-font-t5'
							)}
							value={authorRole}
						/>
					</figcaption>
				</figure>
			</div>
		</section>
	);
};
